import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';

/**
 * Fires a GA4 page_view on every SPA route change.
 * Mount once inside <BrowserRouter>.
 */
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip admin pages from GA tracking — we don't want internal usage polluting metrics
    if (location.pathname.startsWith('/admin')) return;
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
